import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,

  // ✅ Common (shared or ternary conditional)
  PRIMARY_MAIN: IS_ADMIN ? '#f0f2f2' : '#f1f1f1',
  HEADER_COUNT_TEXT: IS_ADMIN ? '#455560' : '#000',
  PRIMARY_CONTRAST: IS_ADMIN ? '#455560' : '#000',
  PRIMARY_BORDER: IS_ADMIN ? '#2d2b2b' : '#d7d7d7',
  GREY: '#999',
  DAILY_LOG_GRAPH_BORDER: '#919191',
  NORMAL_LINK: IS_ADMIN ? '#47545e' : '#646464',
  MODAL_TEXT: '#797979',
  MODAL_HEADING: IS_ADMIN ? '#575757' : '#000',
  MODAL_BACKGROUND: IS_ADMIN ? '#fff' : '#f1f1f1',
  LIST_TEXT: IS_ADMIN ? '#455560' : '#000000',
  HEADER_LIST_TEXT: IS_ADMIN ? '#455560' : '#000000',
  LIGHT_BORDER: '#2d2b2b',
  WHITE: '#fff',
  INPUT_BACKGROUND: IS_ADMIN ? '#ffffff' : '#f1f1f1',
  RED: '#ff0000',
  BLACK: '#000',
  PRIMARY_MODAL_MAIN:'#f1f1f1',
  BLACK_THREE: '#373737',
  RED_TWO: '#d34343',
  GREEN: '#32cd32',
  GREEN_TWO: '#97AE46',
  GREY_ELEVEN: '#777070',
  GREY_TWELVE: '#c3c3c3',
  BLACK_FOUR: '#333333',
  GRAPH_BLACK: '#212121',
  CHART_BLUE: '#00e2ff',
  WARNING: '#ffff00',
  GREY_DATA: '#696969',
  DOCUMENT_LINE: '#2C3249',
  DIABLED_COLOR: IS_ADMIN ? '#889ccc' : 'rgba(0, 0, 0, 0.75)',
  RADIO_BACKGROUND: IS_ADMIN ? '#f0f2f2' : '#f1f1f1',
  FORM_COLOR: IS_ADMIN ? '#191e22' : '#000',
  SUGGESTED_COLOR: '#00b7a0',
  BODY_BACKGROUND: IS_ADMIN ? '#f0f2f2' : '#f1f1f1',
  PAGINATION_BACKGROUND: '#fff',
  PAGINATION_ALTERNATE_BACKGROUND: IS_ADMIN ? '#f8f8f8' : '#f1f1f1',
  PAGINATION_COLOR: '#fff',
  SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
  TITLE_COLOR: '#191e22',
  FORM_BACKGROUND: '#fff',
  FORM_INPUT_BG: IS_ADMIN ? '#f0f2f2' : '#f1f1f1',
  CHECKBOX_BORDER: IS_ADMIN ? '#d1d3d6' : '#d1d1d1',
  SELECT_ACTIONS: IS_ADMIN ? '#444' : '#000',
  SECONDARY_BORDER: IS_ADMIN ? '#d0d4d7' : '#2C3249',
  MULTISELECT_LABEL: IS_ADMIN ? '#f0f2f2' : '#fff',
  TAB_HIGHLIGHT: IS_ADMIN ? '#1589ee' : '#000',
  TAB_HIGHLIGHT_BACKGROUND: IS_ADMIN ? '#fff' : '#d1d1d1',
  ACCORDION_BACKGROUND: '#fff',
  POLICIES_BACKGROUND: '#fff',
  SELECTED_MENU_TITLE: IS_ADMIN ? '#1589ee' : '#000000',
  RANGE_PICKER: {
    CELL_BG: '#dfdfdf',
    CELL_HOVER_BG: '#bbbbbb',
  },
  MAP: {
    LIGHT_BLACK: '#424D66',
    LIGHTER_BLACK: '#424D66',
    BLACK: '#424D66',
    GREY: '#d1d1d1',
    LIGHT_GREY: '#d1d1d1',
    LIGHTER_GREY: '#d1d1d1',
    WATER: '#2B364F',
    ROAD: '#37425C',
  },
  SELECTED_MENU_BG: IS_ADMIN ? 'rgb(15 19 39)' : '#f1f1f1',
  BACKGROUND: IS_ADMIN ? '#fff' : '#1b1b1b',
  LINK_COLOR: IS_ADMIN ? '#1589ee' : '#4d4d4c',
  HEADER_COLOR: IS_ADMIN ? '#061c3f' : '#ffffff',
  INPUT_BORDER: IS_ADMIN ? '#0000004D' : '#d1d1d1',
  CHECKBOX_TICK: IS_ADMIN ? '#1589ee' : '#4d4d4c',
  LOGIN_BUTTON: IS_ADMIN ? '#1589ee' : '#4d4d4c',
  INPUT_COLOR: '#000',
  INPUT_FOCUS: IS_ADMIN ? '#1589ee' : '#5ab8f9',
  BACKGROUND_MENU: IS_ADMIN ? '#455560' : '#d1d1d1',
  TABLE_ROW_COLOR: IS_ADMIN ? '#39434c' : 'rgba(0, 0, 0, 0.75)',
  SORT_ICON: IS_ADMIN ? '#1589ee' : 'rgba(0, 0, 0, 0.75)',
  PAGINATION_HEADER: IS_ADMIN ? '#455560' : 'rgba(0, 0, 0, 0.75)',
  HEADER_TEXT: IS_ADMIN ? '#fff' : '#000',
  PAGINATION_BORDER: IS_ADMIN ? '#f0f2f2' : 'rgba(0, 0, 0, 0.3)',
  RESET_BUTTON: IS_ADMIN ? '#47545e' : 'rgba(0, 0, 0, 0.3)',
  ACTION_BORDER: IS_ADMIN ? '#455560' : 'rgba(0, 0, 0)',
  RESET_COLOR: IS_ADMIN ? '#ffffff' : 'rgba(0, 0, 0)',
  MULTISELECT_BACKGROUND: IS_ADMIN ? '#1589ee' : '#4d4d4c',
  USER_LOGO_BACKGROUND: IS_ADMIN ? '#455560' : '#c3c3c3',
  USER_LOGO_COLOR: IS_ADMIN ? '#ffffff' : '#000',
  MENU_BORDER_COLOR: IS_ADMIN ? '#1589ee' : '#4d4d4c',
  MENU_TITLE: IS_ADMIN ? '#fff' : 'rgba(0, 0, 0, 0.8)',
  MENU_BACKGROUND: IS_ADMIN ? '#061c3f' : '#ffffff',

  // ✅ Admin-only keys
  ...(IS_ADMIN
    ? {
        LOGIN_BACKGROUND: '#061c3f',
        LOGIN_HEAD_TEXT: '#fff',
        LOGIN_INPUTBG: '#fff',
        LIGHT_PRIMARY_BORDER: '#0000004D',
        SECONDARY_MAIN: '#1589ee',
        USER_NAME_COLOR: '#fff',
        SECONDARY_CONTRAST: '#fff',
        HEADER_INFO_DASHBOARD_COLOR: '#fff',
        PRIMARY_BUTTON_TEXT: '#fff',
        RESET_BACKGROUND: '#455560',
        DASHBOARD: {
          CARD: '#fff',
          COLOR: '#000',
        },
        HEADER_FONT_SIZE: 16,
      }
    : {}),

  // ✅ Non-admin-only keys
  ...(IS_ADMIN
    ? {}
    : {
        SELECTED_TAB_COLOR: 'rgba(0, 0, 0, 0.75)',
        TAB_LABEL: 'rgb(69, 85, 96)',
        LOGOUT_BUTTON: '#f1f1f1',
        MULTISELECT_LABEL: '#fff',
        TAB_BOTTOM_BORDER: '#4d4d4c',
        HEADER_LIST_TEXT: '#000000',
        LIGHT_BORDER: '#2d2b2b',
        MODAL_HEADING: '#000',
        FORM_COLOR: '#000',
        DOCUMENT_LINE: '#2C3249',
        PAGINATION_COLOR: '#fff',
        SECONDARY_MAIN: '#a8a8a8',
        FORM_INPUT_BG: '#f1f1f1',
        TAB_HIGHLIGHT: '#000',
        TAB_HIGHLIGHT_BACKGROUND: '#d1d1d1',
      }),
};

export const fonts = ['Open Sans', 'sans-serif'].join(',');
